(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.isBetween = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isBetween;
  /**
   * Checks if a number is between a min and maximum (inclusive)
   *
   * @param {Number} num the number to check
   * @param {Number} min the minimum
   * @param {Number} max the maximum
   * @return {Boolean} true if the number is between the min and max (inclusive)
   */
  function isBetween(num, min, max) {
    return num >= min && num <= max;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/utils/NumberUtils/isBetween.js
// module id = 225
// module chunks = 0